import {
  GET_ITG_RECOMMENDATIONS,
  GET_ITG_RECOMMENDATIONS_SUCCESS,
  GET_ITG_RECOMMENDATIONS_FAILURE,
} from '../actions/itgRecommendations';

const INITIAL_STATE = { loading: true, requested: false };

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_ITG_RECOMMENDATIONS:
      return {
        ...state,
        loading: true,
        error: false,
        requested: true,
      };
    case GET_ITG_RECOMMENDATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: false,
        requested: true,
        data: action.payload,
      };
    case GET_ITG_RECOMMENDATIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        requested: true,
      };
    default:
      return state;
  }
}
